import { Dayjs } from "dayjs";
import { State } from "../enums/State";
import { SmartpricingIntegrationState } from "./enum.smartpricingIntegrationState";

export type SmartpricingSettingsDto = {
  mandantId: number;
  state: State;
  accomodationId: string;
  integrationState: SmartpricingIntegrationState;
  lastSuccessfulRoomsAndRatesConfiguration?: undefined | Dayjs;
  lastSuccessfulReservationsUpdate?: undefined | Dayjs;
  lastSuccessfulPricesRetrieval?: undefined | Dayjs;
  lastSuccessfulLengthOfStaysRetrieval?: undefined | Dayjs;
};

export type SmartpricingSettingsInputDto = {
  state: State;
  accomodationId: string;
  integrationState: SmartpricingIntegrationState;
};

export function mapSmartpricingSettingsDtoToSmartpricingSettingsInputDto(
  smartpricingSettingsDto: SmartpricingSettingsDto,
): SmartpricingSettingsInputDto {
  return {
    state: smartpricingSettingsDto.state,
    accomodationId: smartpricingSettingsDto.accomodationId,
    integrationState: smartpricingSettingsDto.integrationState,
  };
}
